import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import { roundToDecimals } from "../../utils/Utils";

import Rating from "../../utils/components/Rating";

import "../../../styles/components/insights/insights/MyRating.scss";
import star from "../../../styles/images/star_grey.svg";
import "../../../styles/utils/_loadingScreenSmall.scss";



class MyRating extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div id="myRating" className="highlight-container">
        {!this.props.loading ? (
          <div className="highlight-container-header">
            <img src={star} alt="" />
            <Translate value="insights_myOverallRating" />
            <div className="rating">
              <span className="rating-text">
                {this.props.myRating ? (
                  roundToDecimals(this.props.myRating, 1)
                ) : (
                  <Translate className="no-rating" value="insights_noRating" />
                )}
              </span>
              <Rating value={Math.round(this.props.myRating)} />
            </div>
          </div>
        ) : (
          <div className="loading-container">
            <div className="loading-small-spinner">
              <div className="loading-small">
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default MyRating;
